module.exports = __webpack_public_path__ + "static/1-2dc3d6dc851857d7f203d23baa4e8ecf.jpg";